<div
  *renderingPermissionDirective="[
    'DeviceMonitoringWriter',
    'DeviceMonitoringReader',
    'DeviceMonitoringAdmin',
  ]"
  class="device-profile">

  <!-- Back Button & Header -->
  <div class="device-profile__header">
    <button class="lx-btn lx-btn-text device-profile__back-btn" (click)="goBack()">
      <i class="lx-icon lx-chevron-lrg-left"></i>
      DEVICE PROFILE
    </button>
  </div>

  <!-- Loading State -->
  <dcc-spinner *ngIf="loading"></dcc-spinner>

  <!-- Error State -->
  <div *ngIf="error && !loading" class="alert alert-danger">
    An error has occurred. Check devtools console for more info.
    Contact Device Platform team if issues persist.
  </div>

  <!-- Device Profile Content -->
  <div *ngIf="!loading && !error && deviceData" class="device-profile__content">

    <!-- Timeline -->
    <dcc-timeline
      class="device-profile__timeline"
      [endDate]="endDate"
      [monitoringData]="deviceData"
      [serialNumber]="serialNumber"
      [startDate]="startDate"
      (dissociated)="loadData()"
      (dissociationConfirmed)="loadData()">
    </dcc-timeline>

  </div>
</div>
